import { createFolioSearchClient } from '../folioSearchClient';

export const relationshipContactSearch = createFolioSearchClient({
	additionalSearchParameters: {
		sort_by: 'lastUpdated:desc',
	},
});
